// eslint-disable-next-line import/prefer-default-export
import RecommendationSlider from './RecommendationSlider';

export default RecommendationSlider;
